import { createContext, useState } from "react";
import useLocalStorage from "../hooks/useLocalStorage";

interface UploadedFile {
  type: string;
  bucket: string;
  generation: string;
  metageneration: string;
  fullPath: string;
  name: string;
  size: number;
  timeCreated: string;
  updated: string;
  md5Hash: string;
  contentDisposition: string;
  contentEncoding: string;
  contentType: string;
  downloadUrl: string;
  pdfPages: number;
}

interface FileUploadProvider {
  uploadedPages: number;
  uploadedFiles: UploadedFile[];
  setUploadedFiles: React.Dispatch<React.SetStateAction<UploadedFile[]>>;
  additionalNotes: string;
  setAdditionalNotes: React.Dispatch<React.SetStateAction<string>>;
}

export interface FileUploadContextProps {
  fileUpload: FileUploadProvider;
  fileUploadContextClear: any;
  additionalNotes: string;
}

export const FileUploadContext = createContext(null);

export const FileUploadContextProvider = ({ children }: any) => {
  const [uploadedFiles, setUploadedFiles] = useState<UploadedFile[]>([]);
  const [additionalNotes, setAdditionalNotes] = useState<string>("");
  const { clearSessionStorage } = useLocalStorage();

  const uploadedPages = uploadedFiles.reduce(
    (acc: number, item: any) => (acc += item.pdfPages),
    0
  );

  const fileUploadContextClear = () => {
    setUploadedFiles([]);
    setAdditionalNotes("");
    clearSessionStorage();
  };

  const fileUpload = {
    uploadedPages,
    uploadedFiles,
    setUploadedFiles,
    additionalNotes,
    setAdditionalNotes,
  };

  // Global State like "Redux"
  const contextProps: FileUploadContextProps = {
    fileUpload,
    fileUploadContextClear,
    additionalNotes
  };

  return (
    // @ts-ignore
    <FileUploadContext.Provider value={contextProps}>
      {children}
    </FileUploadContext.Provider>
  );
};
